import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stroke-cross",
  "use": "stroke-cross-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"stroke-cross\"><path fill-rule=\"evenodd\" d=\"m5.984 7.493-3.77 3.77-1.51-1.507 3.77-3.772-3.77-3.77L2.213.704l3.771 3.77L9.756.705l1.508 1.508-3.772 3.771 3.772 3.772-1.508 1.508-3.772-3.772z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol